// Generic strings shared across the app.
export const common: Record<string, string> = {
  'Loading…': 'Učitavanje…',
  'Loading...': 'Učitavanje...',
  'Save': 'Sačuvaj',
  'Cancel': 'Otkaži',
  'Delete': 'Obriši',
  'Edit': 'Izmeni',
  'Close': 'Zatvori',
  'Back': 'Nazad',
  'Next': 'Dalje',
  'Search': 'Pretraga',
  'Follow': 'Zaprati',
  'Following': 'Pratiš',
  'Unfollow': 'Otprati',
  'Followers': 'Pratioci',
  'Share': 'Podeli',
  'Copy': 'Kopiraj',
  'Copied!': 'Kopirano!',
  'Submit': 'Pošalji',
  'Confirm': 'Potvrdi',
  'Try again': 'Pokušaj ponovo',
  'Something went wrong': 'Nešto je pošlo po zlu',
  'Something went wrong.': 'Nešto je pošlo po zlu.',
  'View all': 'Prikaži sve',
  'See more': 'Vidi više',
  'Show more': 'Prikaži više',
  'Show less': 'Prikaži manje',
  'Free': 'Besplatno',
  'or': 'ili',
  'and': 'i',
  'today': 'danas',
  'yesterday': 'juče',
};
